goog.provide("shadow.js.shim.module$$embedpdf$react$selection");
goog.provide("module$shadow_js_shim_module$$embedpdf$react$selection");
shadow.js.shim.module$$embedpdf$react$selection = shadow.js.nativeProvides["@embedpdf/react/selection"] = shadow$bridge("@embedpdf/react/selection");
module$shadow_js_shim_module$$embedpdf$react$selection.default = shadow.js.shim.module$$embedpdf$react$selection;
